/** 结果校验：测量项模板（每次解析需 clone，避免污染静态配置） */
const DATA_LIST_TEMPLATE = [
  { label: 'Leq,T(dB)', codeKey: 'leq', value: '' },
  { label: 'L10(dB)', codeKey: 'l10', value: '' },
  { label: 'L50(dB)', codeKey: 'l50', value: '' },
  { label: 'L90(dB)', codeKey: 'l90', value: '' },
  { label: 'LAE(dB)', codeKey: 'lae', value: '' },
  { label: 'Lmax(dB)', codeKey: 'lmax', value: '' },
  { label: 'Lmin(dB)', codeKey: 'lmin', value: '' },
  { label: 'SD(dB)', codeKey: 'sd', value: '' },

  { label: 'LAeq,T(dB)', codeKey: 'laeq', value: '' },
  { label: 'LAmax(dB)', codeKey: 'lamax', value: '' },
  { label: 'LAmin(dB)', codeKey: 'lamin', value: '' },
  { label: 'LCeq,T(dB)', codeKey: 'lceq', value: '' },
  { label: 'LCmax(dB)', codeKey: 'lcmax', value: '' },
  { label: 'LCmin(dB)', codeKey: 'lcmin', value: '' },
  { label: 'LZeq,T(dB)', codeKey: 'lzeq', value: '' },
  { label: 'LZmax(dB)', codeKey: 'lzmax', value: '' },
  { label: 'LZmin(dB)', codeKey: 'lzmin', value: '' },

  { label: '31.5Hz(dB)', codeKey: 'oct31_5', value: '' },
  { label: '63Hz(dB)', codeKey: 'oct63', value: '' },
  { label: '125Hz(dB)', codeKey: 'oct125', value: '' },
  { label: '250Hz(dB)', codeKey: 'oct250', value: '' },
  { label: '500Hz(dB)', codeKey: 'oct500', value: '' },
  { label: '1KHz(dB)', codeKey: 'oct1000', value: '' },
  { label: '2KHz(dB)', codeKey: 'oct2000', value: '' },
  { label: '4KHz(dB)', codeKey: 'oct4000', value: '' },
  { label: '8KHz(dB)', codeKey: 'oct8000', value: '' },

  { label: 'VLeqT(dB)', codeKey: 'vleqT', value: '' },
  { label: 'VLmax(dB)', codeKey: 'vlmax', value: '' },
  { label: 'VLmin(dB)', codeKey: 'vlmin', value: '' },
  { label: 'VL05(dB)', codeKey: 'vl05', value: '' },
  { label: 'VL10(dB)', codeKey: 'vl10', value: '' },
  { label: 'VL50(dB)', codeKey: 'vl50', value: '' },
  { label: 'VL90(dB)', codeKey: 'vl90', value: '' },
  { label: 'VL95(dB)', codeKey: 'vl95', value: '' },
  { label: 'VSD(dB)', codeKey: 'vsd', value: '' },
]

function cloneDataList() {
  return DATA_LIST_TEMPLATE.map((item) => ({ ...item }))
}

/**
 * 将 parseData 返回的 response 转为结果校验展示所需状态（登录弹窗与 H5 页共用）
 */
export function buildResultCheckFromResponse({ crcResponse, measureDataResponse } = {}) {
  const state = {
    crcResponse: crcResponse || null,
    measureDataResponse: measureDataResponse || null,
    list: [],
    measureTime: '',
    tm: '',
    analyzer: '',
    timeWeight: '',
    sta: '',
    frequencyWeight: '',
    lxdb: '',
    lxmv: '',
  }

  if (!measureDataResponse) {
    return state
  }

  const { analyzer, data, frequencyWeight, measureTime, sta, timeWeight, tm } = measureDataResponse
  state.measureTime = measureTime
  state.tm = tm
  state.analyzer = analyzer
  state.timeWeight = timeWeight
  state.sta = sta
  state.frequencyWeight = frequencyWeight

  const dataList = cloneDataList()
  const arr = []

  dataList.forEach((item) => {
    for (const key in data) {
      if (key === 'lxdb') {
        state.lxdb = data[key] ? data[key].toFixed(1) : data[key]
      }
      if (key === 'lxmv') {
        state.lxmv = data[key] ? data[key].toFixed(2) : data[key]
      }
      if (item.codeKey === key) {
        if (analyzer === 'STA') {
          if (item.codeKey === 'leq') {
            item.label = 'Leq,T(dB)'
          } else if (item.codeKey === 'lmax') {
            item.label = 'Lmax(dB)'
          } else if (item.codeKey === 'lmin') {
            item.label = 'Lmin(dB)'
          } else if (item.codeKey === 'lae') {
            item.label = 'SEL(dB)'
          }
        }
        if (analyzer === 'OCTL') {
          if (item.codeKey === 'leq') {
            item.label = 'LAeq,T(dB)'
          } else if (item.codeKey === 'lmax') {
            item.label = 'LAFmax(dB)'
          } else if (item.codeKey === 'lmin') {
            item.label = 'LAFmin(dB)'
          }
        }
        item.value = data[key] ? data[key].toFixed(1) : data[key]
        arr.push(item)
      }
    }
  })

  state.list = arr
  return state
}
